import { Country } from 'library/ts/model/enums/geo/Country';
import { Constants } from 'tag/ts/smart_tag/model/Constants';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
export const DEFAULT_RELATIVE_VALUE = true;
export const DefaultSmartTagReadyCallback = {
    env: EmbedType.DESKTOP,
    country: Country.US,
    locale: 'en-us',
    delay: undefined,
    method: Constants.getInstance().FUNCTION_SMART_TAG_ON_READY,
    namespace: undefined,
    payload: {
        relative: DEFAULT_RELATIVE_VALUE
    },
    newRelic: false,
    platformConfig: {
        DEFAULT: {
            CHROME: {
                minVersion: 68
            },
            FIREFOX: {
                minVersion: 48
            },
            SAFARI: {
                minVersion: 9
            },
            EDGE: {
                minVersion: 14
            },
            IE: {
                disable: true
            },
            OPERA: {
                disable: true
            }
        },
        WINDOWS_XP: {
            FIREFOX: {
                minVersion: 52
            }
        },
        WINDOWS_VISTA: {
            FIREFOX: {
                minVersion: 52
            }
        }
    },
    detectAutoplay: true
};
